// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"999f9465","960":"7a5ee4d8"}[chunkId] + ".chunk.js";
};